import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { ApiService } from '@shared/services/api.service'
import { withFeedback } from '@app/core/interceptors/feedback-context'
import { Driver } from '@shared/models/driver.model'
import { DocumentRow, DriverDocumentItem, DocumentItem } from '../documents/document.model'
import { FilterValues } from '@shared/models/filter-values.model'
import { ExportFileTypes } from '@shared/models/export-file-types.enum'

@Injectable({ providedIn: 'root' })
export class DriverDocumentService {
  constructor(private apiService: ApiService) {}

  getList(
    driverId: number | null,
    pageIndex = 0,
    pageSize = 10,
    sort?: string,
    filterValues?: { [param: string]: string | number | string[] },
    fields?: (keyof DocumentRow)[],
  ) {
    const url = driverId ? `/drivers/${driverId}/documents` : '/drivers/documents'
    const toDriver = (document: DriverDocumentItem) => ({ ...document, driver: new Driver(document.driver) })

    return this.apiService
      .getPageable<DocumentRow>(url, pageIndex, pageSize, sort, filterValues, fields)
      .pipe(map(({ meta, data }) => ({ meta, data: data.map(toDriver) })))
  }

  exportFile(
    driverId: number | null,
    columns: string[],
    sort: string,
    filterValues: FilterValues,
    type: ExportFileTypes,
  ): Observable<string> {
    const url = driverId ? `/drivers/${driverId}/documents/${type}` : `/drivers/documents/${type}`
    return this.apiService.exportFile(url, columns, sort, filterValues)
  }

  upgrade(id: number): Observable<DriverDocumentItem> {
    const toDocumentWithDriver = (driverDocument: DriverDocumentItem) => ({ ...driverDocument, driver: new Driver(driverDocument.driver) })
    return this.apiService.post(`/documents/${id}/upgrade`, null, { context: withFeedback() }).pipe(
      map((response) => response['data']),
      map((documentItem) => new DocumentItem(documentItem)),
      map(toDocumentWithDriver),
    )
  }
}
